import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { CompraService } from "../../services/CompraService";

export default {
  name: "GerenciarCompras",
  components: {
    Breadcrumb,
    StandardPagination,
    ActionButtons
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Licitações',
        disabled: false
      },
      {
        text: 'Gerenciar Processos',
        disabled: true
      }
    ],
    headers: [
      { text: 'Nome da Unidade', align: 'center', value: 'nome_unidade_compra', sortable: true }, 
      { text: 'Ano do Processo', align: 'center', value: 'ano_processo', sortable: true }, 
      { text: 'Tipo de Licitação', align: 'center', value: 'tipo_licitacao', sortable: true }, 
      { text: 'Tipo de Processo', align: 'center', value: 'tipo_processo', sortable: true }, 
      { text: 'Situação', align: 'center', value: 'situacao_execucao_processo', sortable: true },
      { text: 'Valor Total', align: 'center', value: 'valor_total', sortable: true },
      { text: 'Data de Conclusão', align: 'center', value: 'data_conclusao_processo', sortable: true },
    ],
    
    filters: {
      nomeCompraFilter: '',
      anoProcessoFilter: '',
      tipoLicitacaoFilter: '',
      situacaoExecucaoFilter: '',
    },
    
    tipoLicitacaoOptions: [
      { text: 'Menor Preço', value: 'Menor Preço' },
      { text: 'Melhor Técnica', value: 'Melhor Técnica' },
      { text: 'Técnica e Preço', value: 'Técnica e Preço' },
      { text: 'Maior Lance', value: 'Maior Lance' }
    ],
    
    situacaoOptions: [
      { text: 'Em Execução', value: 'Em Execução' },
      { text: 'Não Iniciada', value: 'Não Iniciada' },
      { text: 'Concluída', value: 'Concluída' },
      { text: 'Cancelada', value: 'Cancelada' }
    ],
    
    anoOptions: [
      { text: '2024', value: '2024' },
      { text: '2023', value: '2023' },
      { text: '2022', value: '2022' },
      { text: '2021', value: '2021' },
      { text: '2020', value: '2020' }
    ],
    
    items: [],
    itemSelected: [],
    page: 1,
    totalItems: 0,
    itemsPerPage: 10,
    itemsPerPageOptions: [10, 20, 50, 100],
    showFilters: true
  }),
  
  computed: {
    computedHeaders() {
      return this.headers;
    },
    
    isAllSelected() {
      return this.items.length > 0 && this.itemSelected.length === this.items.length;
    },
    
    isIndeterminate() {
      return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
    }
  },
  
  created() {
    this.listarComprasPaginado();
  },
  
  watch: {
    page: async function(newValue) {
      this.page = newValue;
      await this.listarComprasPaginado();
    },
    'filters.nomeCompraFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1;
        this.listarComprasPaginado();
      }
    },
    'filters.anoProcessoFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1;
        this.listarComprasPaginado();
      }
    },
    'filters.tipoLicitacaoFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1;
        this.listarComprasPaginado();
      }
    },
    'filters.situacaoExecucaoFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1;
        this.listarComprasPaginado();
      }
    }
  },
  
  methods: {
    async listarComprasPaginado() {
      try {
        const filter = this.prepareFormFilter();

        const response = await CompraService.index(filter);

        if (typeof response !== 'string') {
          this.items = response.data.data;
          this.totalItems = response.data.total;
          this.itemSelected = [];
          this.$forceUpdate();
        } else {
          console.error('Não foi possível obter os Processos de Compras.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao listar os Processos de Compras:', error);
      }
    },
    
    handleVisualizarCompra() {
      if (this.itemSelected.length === 1) {
        this.$router.push(`/processos-compras/visualizar/${this.itemSelected[0].id}`);
      }
    },
    
    handleExportar() {
      this.$globalAlert('Não implementado!');
    },
    
    async destroyCompras() {
      try {
        const ids = this.itemSelected.map(compra => compra.id);

        const formData = new FormData();

        ids.forEach(id => {
          formData.append("compras[]", id);
        });

        const response = await CompraService.destroy(formData);

        if (!response) {
          console.error('Não foi possível excluir as compras.');
        }

        this.listarComprasPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao excluir as compras:', error);
      }
    },
    
    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);

      if (this.filters.nomeCompraFilter) {
        filter.append("nome_unidade_compra", this.filters.nomeCompraFilter);
      }

      if (this.filters.anoProcessoFilter) {
        filter.append("ano_processo", this.filters.anoProcessoFilter);
      }

      if (this.filters.tipoLicitacaoFilter) {
        filter.append("tipo_processo", this.filters.tipoLicitacaoFilter);
      }

      if (this.filters.situacaoExecucaoFilter) {
        filter.append("situacao_execucao_processo", this.filters.situacaoExecucaoFilter);
      }

      return filter;
    },
    
    // Métodos para filtros
    clearFilters() {
      this.filters = {
        nomeCompraFilter: '',
        anoProcessoFilter: '',
        tipoLicitacaoFilter: '',
        situacaoExecucaoFilter: '',
      };
      this.page = 1;
      this.listarComprasPaginado();
    },
    
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    
    // Métodos para paginação
    handlePageChange(newPage) {
      this.page = newPage;
    },
    
    handleItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.listarComprasPaginado();
    },
    
    // Métodos para seleção
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.itemSelected = [];
      } else {
        this.itemSelected = [...this.items];
      }
    },
    
    getRowClass() {
      return 'custom-row';
    },
    
    // Métodos para formatação
    truncateText(text, maxLength) {
      if (!text) return '-';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    formatCurrency(value) {
      if (!value || value === 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    
    getSituacaoColor(situacao) {
      switch (situacao) {
        case 'Em Execução':
          return 'green';
        case 'Execução não iniciada':
          return 'yellow';
        case 'Concluída':
          return 'blue';
        case 'Cancelada':
          return 'red';
        default:
          return 'grey';
      }
    }
  }
};